import React, { useEffect, useState } from 'react';
import GroupInput from './UTMFields/GroupInput';
import DetailHeaders from './DetailHeaders.js';
import DetailItem from './DetailItem.js';
import DetailActions from './DetailActions.js';
import axios from 'axios';
import { newUTM } from './helpers';

export default function DetailView({ changeView, curBatch, configs, setOffset }) {
  const [utmBatch, setUTMBatch] = useState({}); // current UTM batch's full meta data
  const [newUTMList, updateUTMList] = useState([]); // UTM codes from batch rendered to view
  // const [configs, setConfigs] = useState({}); // fetched configs for select dropdowns
  const [loading, setLoading] = useState(true);
  const [showTable, setShowTable] = useState(false);

  //track error handling and disbale continue if errors are present
  const[error, setError] = useState(false)
  //set the batch id if its not a new Utm group
  let { batch_id } = curBatch;

  const isEmpty = (obj) => Object.keys(obj).length === 0;

  const renderUTMList = () =>
    newUTMList.map((item) => {
      return (
        <DetailItem
          key={item.id}
          item={item}
          updateUTMList={updateUTMList}
          newUTMList={newUTMList}
          configs={configs}
          setError={setError}
        />
      );
    });

  const updateBatch = () => {
    let newState = { ...utmBatch };
    newState.utm_codes = newUTMList;
    setUTMBatch(newState);
  };

  const fetchUTMData = async (batch_id) => {
    await axios
      .post(' /wp-admin/admin-ajax.php?action=post_get_utm_by_batch', {
        batch_id
      })
      .then(
        ({
          data: {
            data: { utm_batch }
          }
        }) => {
          const utmCodes = utm_batch.utm_codes;
          setUTMBatch(utm_batch);

          utmCodes.length === 0
            ? updateUTMList([newUTM()])
            : updateUTMList(utmCodes);

            setShowTable(!!batch_id); // set showTable to true if batch is not new
            setLoading(false)
        }
      );
  };

  const createUTMPost = async () => {
    const url = `/wp-admin/admin-ajax.php?action=post_save_utm_codes`;

    await axios
      .post(url)
      .then((res) => {
        batch_id = res.data.data;
        fetchUTMData(batch_id);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    updateBatch();
    renderUTMList();
  }, [newUTMList]);

  useEffect(() => {
    newUTMList.length > 0 && !isEmpty(configs)
      ? setLoading(false)
      : setLoading(true);
  }, [newUTMList, configs]);

  // Fetch UTMs by Batch ID or create New UTM Batch Post ID then Fetch Fresh Post
  useEffect(() => {
    // if batch_id is present fetching the specific utm data, if not we're showing the empty table
    if (batch_id !== '') {
      fetchUTMData(batch_id);
    } else {
      updateUTMList([newUTM()])
      setShowTable(true);
      setLoading(false);
    }
  }, [curBatch]);

  return (
    <div className="container u--margin-top-35">
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div>
          <GroupInput
            changeView={changeView}
            utmBatch={utmBatch}
            setUTMBatch={setUTMBatch}
            setShowTable={setShowTable}
            showTable={showTable}
            batch_id={batch_id}
            setOffset={setOffset}
          />
          {showTable ? (
            <div>
              <div className="utm__table">
                <DetailHeaders />
                {renderUTMList()}
              </div>
              <DetailActions
                addUTM={updateUTMList}
                curList={newUTMList}
                utmBatch={utmBatch}
                changeView={changeView}
                error={error}
                setOffset={setOffset}
              />
            </div>
          ) : (
            <div></div>
          )}
        </div>
      )}
    </div>
  );
}
